import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-merge",
  "use": "icon-merge-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-merge\"><path d=\"M99.03 190.069c1.252-.626 197.114 1.254 197.114 1.254l133.649 217.171-43.441 71.826-128.205-208.185H100.283s-46.985-40.719-1.253-82.066zm843.609 305.286L734.873 350.439l.625 101.484H514.99L352.113 752.619s-238.048-.831-238.891-.831c-58.456 45.514 0 81.016 0 81.016l275.225-.419L545.902 532.11l191.261 1.675v96.882l205.476-135.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol